import axios, { type AxiosRequestHeaders } from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL ?? "http://localhost:3600/api/v1";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json"
  }
});

const getStoredSession = () => {
  const raw = localStorage.getItem("issp.session");
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as { accessToken: string; refreshToken: string };
  } catch {
    localStorage.removeItem("issp.session");
    return null;
  }
};

apiClient.interceptors.request.use((config) => {
  const session = getStoredSession();
  if (session?.accessToken) {
    if (!config.headers) {
      config.headers = {} as AxiosRequestHeaders;
    }
    (config.headers as AxiosRequestHeaders)["Authorization"] = `Bearer ${session.accessToken}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.removeItem("issp.session");
        window.location.href = "/auth/login";
        return Promise.reject(new Error("Session expired. Please log in again."));
      }

      if (error.response.status === 403) {
        return Promise.reject(new Error("You do not have permission to perform this action."));
      }

      if (error.response.status === 429) {
        return Promise.reject(new Error("Too many requests. Please try again later."));
      }
    }
    return Promise.reject(error);
  }
);
